import * as React from "react";

import Footer from "../../../../layouts/Footer";
import Header from "../../../../layouts/Header";
import Layout from "../../../../layouts/Layout";

import { SubscriptionsLayout, SubscriptionsBox, SubscriptionsToolbar, SubscriptionsSettings, SubscriptionsMenu } from "../../components";
import { SubscriptionsProvider } from "../../providers";

const SubscriptionsPage: React.FC = () => {
  return (
    <Layout>
      <Header />
      <SubscriptionsProvider>
        <SubscriptionsLayout>
          <SubscriptionsToolbar />
          <SubscriptionsBox>
            <SubscriptionsMenu />
            <SubscriptionsSettings />
          </SubscriptionsBox>
        </SubscriptionsLayout>
      </SubscriptionsProvider>
      <Footer />
    </Layout>
  );
};

export default SubscriptionsPage;
